// jQuery will be available via <script>
/* global $, SKETCH_RELEASES */
import Mustache from 'mustache'
import { BASE_API_URL } from '../../base/endpoints'

var registrationToken
var registrationEmail
var INVOICES_SHOWN_BY_DEFAULT = 2

$(document).ready(function () {
  // Parse Mustache template now, so rendering will be faster
  var template = $('#template').html()
  Mustache.tags = ['[[[', ']]]']
  Mustache.parse(template)

  //
  // Fill login form & submit if both fields are filled
  //
  var fillFormFromURL = function () {
    var $licenseEmailField = $('#license-email')
    var $licenseTokenField = $('#access-token')
    var $licenseForm = $('#license-manager-login-form')

    // only proceed if we have a login form
    if ($licenseForm.length !== 0) {
      // get the url query string in an object
      var urlQueryString = Sketch.utils.parseQueryString()

      if (urlQueryString && urlQueryString.auth) {
        // auth should be Base64 encoded, decode using "atob" method
        var authQuery = window.atob(urlQueryString.auth)

        // comes in "email=me@example.com&token=mYtOken" format
        var auth = Sketch.utils.parseQueryString(authQuery)

        // fill fields values
        if (auth.email) {
          $licenseEmailField.val(auth.email)
        }

        if (auth.token) {
          $licenseTokenField.val(auth.token)
        }

        // if both exist, submit form automatically
        if (auth.email && auth.token) {
          $licenseForm.submit()
        }
      }
    }
  }

  /*
   * getValidRelease function determines which Sketch version is supported for a given license
   * expiration date. This function now uses UTC dates to ensure consistent results across
   * all user timezones, preventing the issue where different timezones would see different
   * supported versions for the same license.
   */
  var getValidRelease = function (licenseTime) {
    var main
    var minor
    var date
    var dateTime
    var dateArr
    var isMain
    var prevRelease

    //
    // Main releases before 39 were calculated differently
    //
    var isMainRelease = function (release) {
      var releaseNum = parseInt(release.version)
      var result
      if (releaseNum >= 39) {
        result = !(release.version.indexOf('.') > -1)
      } else {
        result = release.version.split('.').length == 2
      }
      return result
    }

    SKETCH_RELEASES.forEach(function (release) {
      isMain = isMainRelease(release)
      dateArr =
        release.support_date && release.support_date !== ''
          ? release.support_date.split('-')
          : release.release_date.split('-')
      // Use UTC to avoid timezone discrepancies
      date = new Date(Date.UTC(parseInt(dateArr[0]), parseInt(dateArr[1]) - 1, parseInt(dateArr[2])))
      dateTime = date.getTime()

      //
      // Before: if (!main && prevRelease && isMainRelease(prevRelease)) {
      //
      // If:
      //  there's no Main version found yet
      //  and there's a previous main release found OR no previous main release (most recent version)
      //
      if (!main && (!prevRelease || (prevRelease && isMainRelease(prevRelease)))) {
        minor = release.version
      }

      // valid
      if (!main && isMain && licenseTime >= dateTime) {
        main = release.version
      }

      prevRelease = release
    })

    if (!minor) {
      minor = main
    }

    return {
      main: main,
      minor: minor,
    }
  }

  // Login
  $('#license-manager-login-form').validate({
    errorClass: 'invalid',
    errorElement: 'div',
    rules: {
      'access-token': {
        required: true,
        email: false,
      },
    },
    // Removing error messages, to avoid duplication with the placeholders
    messages: {
      'license-email': '',
      'access-token': '',
    },
    // Eager validation
    onfocusout: function (element) {
      this.element(element)
    },
    submitHandler: function () {
      $('#submit').addClass('is-waiting')
      $('.license-manager-login-form__input').attr('disabled', 'disabled')

      // Forcing the browser to scroll Up before showing the content
      window.scrollTo(0, 0)

      // console.log("This is what I'm sending", fData);
      $.ajax({
        type: 'POST',
        url: `${BASE_API_URL}licensemanager/overview/`,
        data: {
          // Submit the data via AJAX to the API
          token: $('#access-token').val(),
          email: $('#license-email').val(),
        },
        dataType: 'json',
        encode: true,
      })
        // AJAX Sucess
        .done(function (response) {
          // console.log("This is response.data", response.data);
          // console.log("This is response", response);
          registrationEmail = $('#license-email').val()
          registrationToken = $('#access-token').val()

          // If we can't find your key
          if (response.data.matches === 0) {
            // Hide the form
            $('#license-manager-login-form').hide()

            // Hide initial content
            $('.main-content h1 #license-manager-access').hide()
            $('.main-content p #license-manager-instructions').hide()

            // Display Error message
            $('.main-content h1 #access-code-not-recognized').show()
            $('.main-content p #access-code-instructions').show()

            // Contact Customer Support call to action
            $('.main-content p#contact_customer_support').show()
            // MAS alert note
            $('.main-content p#mas_alert').show()
            // Retry button
            $('.main-content p#retry_button')
              .show()
              .click(function () {
                // Restore header & instructions
                $('.main-content h1 #license-manager-access').show()
                $('.main-content p #license-manager-instructions').show()
                $('.main-content h1 #access-code-not-recognized').hide()
                $('.main-content p #access-code-instructions').hide()

                // Hide all other <p>s
                $('.main-content p#contact_customer_support').hide()
                $('.main-content p#mas_alert').hide()
                $('.main-content p#retry_button').hide()

                // Re-enable form for submit again
                $('#submit').removeClass('is-waiting')
                $('.license-manager-login-form__input').removeAttr('disabled')
                // Display the form again
                $('#license-manager-login-form').show()
              })
          } else if (response.data.matches === 1) {
            // If we find your key & email
            $('#license-manager-login').remove()
            $('#license-manager-login').parents('.sidebar').removeClass('sidebar')
            $('#license-manager-table').show()

            // Let's add some helpers to the data
            response.data.niceDateRegistered = function () {
              return Sketch.utils.niceDateFromTimestamp(this.registered_at)
            }
            response.data.niceDateUpdated = function () {
              return Sketch.utils.niceDateFromTimestamp(this.last_update)
            }
            response.data.nicePurchaseDate = function () {
              return Sketch.utils.niceDateFromTimestamp(this.purchaseDate)
            }
            response.data.base64 = function () {
              return function (string, render) {
                if (window.btoa) {
                  return window.btoa(render(string))
                }
                return ''
              }
            }
            // this is a slightly better way to use methods in Mustache
            response.data.niceDate = function () {
              return function (date, render) {
                return Sketch.utils.niceDateFromTimestamp(render(date))
              }
            }
            response.data.showInvoicesMore = function () {
              var invoices = this.invoices
              return invoices.length > INVOICES_SHOWN_BY_DEFAULT
            }
            response.data.invoicesMoreCount = function () {
              var invoices = this.invoices
              return invoices.length - INVOICES_SHOWN_BY_DEFAULT
            }
            response.data.license_index = 1
            response.data.licenseIndex = function () {
              return response.data.license_index++
            }

            response.data.isSingularOrPlural = function () {
              return function (string, render) {
                var val = parseInt(render(string))
                return val > 1 ? 'is-plural' : val === 0 ? 'is-zero' : 'is-singular'
              }
            }

            // calculate total ACTIVE licenses
            response.data.activeLicenses = 0

            // calculate total ACTIVE seats
            response.data.seatCount = 0

            // calculate expiring licenses
            response.data.licensesExpiring = 0

            response.data.licensesExpired = 0

            var sortByDate = function (a, b) {
              var numA = parseInt(a.date)
              var numB = parseInt(b.date)
              if (numA < numB) return 1
              if (numA > numB) return -1
              return 0
            }

            $.each(response.data.licenses, function (i, d) {
              var expired = d.expired
              var dateDiff
              var expirationDateTime
              var data = d
              var validRelease
              var licenseStr = data.license_key

              expirationDateTime = parseInt(d.update_expirationdate) * 1000

              if (!expired) {
                // Use UTC for consistent date comparison across timezones
                const currentDateUTC = new Date()
                const expirationDateUTC = new Date(expirationDateTime)

                // Convert to UTC dates for comparison (set time to 00:00:00 UTC)
                const currentUTCMidnight = new Date(
                  Date.UTC(currentDateUTC.getUTCFullYear(), currentDateUTC.getUTCMonth(), currentDateUTC.getUTCDate())
                )
                const expirationUTCMidnight = new Date(
                  Date.UTC(
                    expirationDateUTC.getUTCFullYear(),
                    expirationDateUTC.getUTCMonth(),
                    expirationDateUTC.getUTCDate()
                  )
                )

                dateDiff = expirationUTCMidnight.getTime() - currentUTCMidnight.getTime()

                //
                // if can renew and expiration date is in the future, count as an expiring license
                //
                response.data.licensesExpiring += d.can_renew && dateDiff >= 0 ? 1 : 0

                response.data.activeLicenses += 1
                response.data.seatCount += parseInt(d.max_number_of_registrations)
              } else {
                data.is_expiring = false
                data.updates_expired = true
                response.data.licensesExpired += 1
              }

              //
              // Which Sketch version can be installed with this license
              //
              validRelease = getValidRelease(expirationDateTime)

              data.sketchValidMainRelease = validRelease.main
              data.sketchValidRelease = validRelease.minor
              data.sketchVersionUrl =
                '/releases/mac/?expiration_date=' +
                expirationDateTime / 1000 +
                '&serial=' +
                window.btoa(licenseStr) +
                '#version-' +
                data.sketchValidRelease

              data.invoices.sort(sortByDate)

              response.data.licenses[i] = data
            })

            //
            // /end of data editing
            //

            $('#license-manager-output').html(Mustache.render(template, response.data))

            // Forcing the browser to scroll Up AFTER showing the content
            window.scrollTo(0, 0)

            // Check the checkbox on row click
            $('.license-device-list tbody tr').click(function (event) {
              if (event.target.type !== 'checkbox') {
                $(':checkbox', this).trigger('click')
              }
            })

            // Highlight the selected row
            $(".license-device-list tbody input[type='checkbox']").change(function () {
              if ($(this).is(':checked')) {
                // If the checkbox is checked
                // Add class on checkbox checked
                $(this).closest('tr').addClass('row-selected')
                // Enable the button
                $(this).parents('form').find("[data-action='unlink']").removeAttr('disabled')
              } else {
                // Remove class on checkbox uncheck
                $(this).closest('tr').removeClass('row-selected')
                // Remove check from the "all"
                $(this)
                  .parents('.license-device-list')
                  .find('table th input[type=checkbox]:checked')
                  .prop('checked', false)

                // If there aren't any other checkboxes checked, disable the button again
                if ($(this).parents('form').find(':checkbox:checked').length == 0) {
                  $(this).parents('form').find("[data-action='unlink']").attr('disabled', 'disabled')
                }
              }
            })

            var tableOrderBy = function ($table, fld, ord) {
              var $rows = $table.find('tbody tr').get()
              var currentBy = $table.attr('data-orderby')
              var currentOrder = $table.attr('data-order')
              var field = fld || currentBy
              var order = 'asc'

              if (currentBy == field && !ord) {
                order = currentOrder == 'asc' ? 'desc' : 'asc'
              }

              $rows.sort(function (a, b) {
                var attr = 'data-' + field
                var $a = order == 'asc' ? a : b
                var $b = order == 'asc' ? b : a
                var keyA = $a.find('[' + attr + ']').attr(attr)
                var keyB = $b.find('[' + attr + ']').attr(attr)

                if (field == 'name') {
                  keyA = keyA[0].toLowerCase()
                  keyB = keyB[0].toLowerCase()
                }

                if (keyA < keyB) return 1
                if (keyA > keyB) return -1
                return 0
              })

              $.each($rows, function (index, row) {
                $table.children('tbody').append(row)
              })

              $table.attr('data-order', order)
              $table.attr('data-orderby', field)

              $table.find('[data-table-orderby]').removeClass('active')
              $table.find('[data-table-orderby="' + field + '"]').addClass('active')
            }

            // table toggle order
            $('[data-table-orderby]').on('click', function () {
              var $el = $(this)
              var order = $el.attr('data-table-orderby')
              var $table = $el.parents('table')
              // var $els = $table.find('[data-' + order + ']')

              tableOrderBy($table, order)
            })

            // Select/Deselect all
            $('.license-device-list table th input[type=checkbox]').click(function () {
              if ($(this).is(':checked')) {
                // Select all
                $(this)
                  .parents('.license-device-list')
                  .find('tbody input[type=checkbox]:not(:checked)')
                  .trigger('click')
              } else {
                // Deselect all
                $(this).parents('.license-device-list').find('tbody input[type=checkbox]:checked').trigger('click')
              }
            })

            //
            // toggle view of inactive licenses
            //
            var toggleInactiveLicenses = function (to) {
              if (to === true) {
                $('[data-is-inactive-toggled]').hide()
                $('[data-license-active="false"]').show()
              } else {
                $('[data-is-inactive-toggled]').show()
                $('[data-license-active="false"]').hide()
              }
            }

            $('[data-toggle]').on('click', function (e) {
              e.preventDefault()

              var $el = $(this)
              var $target = $($el.attr('data-toggle'))

              $target.prop('checked', !$target.prop('checked'))
              $target.trigger('change')
            })

            $('[name="show-inactive-licenses"]').on('change', function () {
              toggleInactiveLicenses($(this).is(':checked'))
            })

            toggleInactiveLicenses($('[name="show-inactive-licenses"]').is(':checked'))

            // Confirmation dialog
            $("[data-action='unlink']").on('click', function (event) {
              // If the confirmation dialog exists, don't do anything
              if ($(this).parent().find('.confirmation-dialog').length === 0) {
                event.preventDefault()
              }

              // Remove the dialog if present
              $('.confirmation-dialog').remove()

              // Disable the rows, so you can't select/deselect anything
              $(this).parents('form').find('tr').attr('disabled', 'disabled')
              // Change the text of the button
              $(this).text('Unlink')
              // Create the confirmation dialog
              $(this)
                .parent()
                .prepend(
                  '<span class="confirmation-dialog"><small>Are you sure you want to unlink the selected device/s?</small><button type="reset" class="button">Cancel</button></span>'
                )
              // Reset the form on cancel
              $('button[type=reset]').click(function () {
                $(this).parents('form')[0].reset()
                $(this).parents('form').find('tr').removeClass('row-selected')
                $(this)
                  .parents('form')
                  .find("[data-action='unlink']")
                  .text('Unlink Selected')
                  .attr('disabled', 'disabled')
                $(this).parents('form').find('tr').removeAttr('disabled')
                $('.confirmation-dialog').remove()
              })
            })

            $("[data-action='more-invoices']").on('click', function (e) {
              e.preventDefault()
              $(this).addClass('hide').parents('form').find('.more-invoices').addClass('show')
            })

            // Delete devices
            $('.main-content form').submit(function (event) {
              event.preventDefault()
              var registrationLicenseKey = $(this).attr('data-license')

              var formData = {
                token: registrationToken,
                email: registrationEmail,
                license: registrationLicenseKey,
              }
              // Add udids to the array
              formData.udids = $(this)
                .find('tbody :checkbox:checked')
                .map(function () {
                  return $(this).val()
                })
                .get()

              $(this).find("[data-action='unlink']").addClass('is-waiting')
              $('.confirmation-dialog').remove()

              // console.log("This is what I'm sending", formData);
              $.ajax({
                type: 'POST',
                url: `${BASE_API_URL}licensemanager/registration/delete/`,
                data: formData,
                dataType: 'json',
                encode: true,
              })
                // AJAX Sucess
                .done(function (res) {
                  // console.log("This is response.data", response.data);
                  // console.log("This is response", response);
                  // console.log("This is response.data.result", response.data.result);

                  if (res.data.matches === 1) {
                    $.each(res.data.result, function (idx, obj) {
                      $.each(obj, function () {
                        if (obj.deleted === 1) {
                          // console.log("Deleted Device:", obj.udid);

                          // Only the selected udids associated to that key
                          var tr = $(
                            'form[data-license=' + registrationLicenseKey + '] input[value=' + obj.udid + ']'
                          ).closest('tr')
                          tr.fadeOut(1000, function () {
                            tr.remove()
                            $("[data-action='unlink']")
                              .text('Unlink Selected')
                              .removeClass('is-loading')
                              .addClass('is-successful')
                            setTimeout(function () {
                              $("[data-action='unlink']")
                                .removeClass('is-waiting is-successful')
                                .attr('disabled', 'disabled')
                              $('form tr').removeAttr('disabled')
                            }, 2000)

                            var rowsLeft = $('form[data-license=' + registrationLicenseKey + '] table tbody tr').length
                            $('form[data-license=' + registrationLicenseKey + '] .devices-left').html(rowsLeft)
                            // If there are no more devices left to delete
                            if (rowsLeft < 1) {
                              // TODO: see if we can use Mustache for this too
                              $('form[data-license=' + registrationLicenseKey + '] table').remove()
                              $('form[data-license=' + registrationLicenseKey + '] .license-device-list')
                                .append("<span class='no-devices'>No devices linked to this license.</span>")
                                .addClass('empty')
                              $('form[data-license=' + registrationLicenseKey + "] [data-action='unlink']").remove()
                            }
                          })
                        }
                      })
                    })
                    if (res.data.limit_reached) {
                      $('form[data-license=' + registrationLicenseKey + "] input[type='checkbox']").each(function () {
                        this.checked = false
                        this.disabled = true
                      })

                      $('form[data-license=' + registrationLicenseKey + '] table tr').removeClass('row-selected')

                      $(
                        'form[data-license=' + registrationLicenseKey + '] .license-manager-controls .cant-unlink'
                      ).show()

                      $('form[data-license=' + registrationLicenseKey + '] .license-manager-controls button').hide()
                    }
                  } else {
                    alert('Error while unlinking device')
                  }
                })
                // AJAX API Error message
                .fail(function (request, textStatus, errorThrown) {
                  alert('An error occurred. Please try again.')
                  console.log('textStatus: ', textStatus, 'errorThrown: ', errorThrown)
                })
                .always(function () {
                  $("[data-action='unlink']").removeClass('is-waiting')
                })
            })
          }
        })
        // AJAX API Error message
        .fail(function (request, textStatus, errorThrown) {
          $('#submit').removeClass('is-waiting').addClass('error')
          setTimeout(function () {
            $('#submit').removeClass('is-waiting error')
            $('.form-field').removeAttr('disabled')
            $('.license-manager-login-form__input').removeAttr('disabled')
          }, 3000)
          // Remove previous message (if any)
          $('.submit').children('small').remove()
          $('.submit').append('<small>An error occurred. Please try again.</small>')
          console.log('textStatus: ', textStatus, 'errorThrown: ', errorThrown)
        })
    },
  })

  // Fill form with url parameters
  fillFormFromURL()
})
